import React, { ReactNode } from "react";
import Header from "./Header";
import Footer from "./Footer";
import BackgroundMusic from "../BackgroundMusic";
import ChatBox from "../ChatBox";
import QuizResumer from "../QuizResumer";
import AnnouncementBanner from "../AnnouncementBanner";
import LiveStreamBanner from "../LiveStreamBanner";

// Interface cho Layout component
interface LayoutProps {
  children: ReactNode;
}

// Component Layout chính của website
const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="h-full w-full flex flex-col bg-gray-50 dark:bg-gray-900 overflow-y-auto custom-scrollbar">
      <LiveStreamBanner />
      <AnnouncementBanner />
      {/* Header */}
      <Header />

      {/* Main Content */}
      <main className="flex-1 pt-16">{children}</main>

      {/* Footer */}
      <Footer />

      {/* Global ChatBox */}
      <ChatBox />

      {/* Quiz Resumer Modal */}
      <QuizResumer />
    </div>
  );
};

export default Layout;
